import React, { useContext, useEffect, useMemo } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import "./Header.css";
import {DocNavigation, EpicInformation, FileInformation} from "./Components";
import * as msg from "../../../utils/constants/messages";
import { Info } from "@mui/icons-material";
import * as c from "utils/constants/constants";

const Header = (props) => {
    const { data = {}, duplicateDocumentView, _baseClassName, } = useContext(DocumentDetailContext);

    const isDocSplitStuck = useMemo(() => {
        const { Entity_Details = {} } = data;
        if ("docSplit") {
            let flag = (Entity_Details.enable_doc_split == false && Entity_Details?.docSplitData?.length && splitInprogress());
            return flag;
        }
        return false
    }, [data]);

    const docMessage = useMemo(() => {
        if (data?.Entity_Details?.fax_cover_page_drop?.status === "In Progress") {
            return msg.coverpage_inprogress
        } else if (data.Status === "Failed" && data.Failure_Message) {
            return data?.Failure_Message + ". " + [5003, 5008, 5009].includes(data.Error_Code) ? "" : msg.block_edits
        } else if (data.Status === "Uploading to EHR") {
            return msg.doc_uploading
        } else if (data.Status === "Uploaded to EHR") {
            return msg.doc_uploaded
        } else if (data.Status === "Marked for Completion") {
            return msg.doc_move
        } else if (data.Status === "Completed") {
            return msg.doc_cmp
        } else return null
    }, [data])

    function splitInprogress() {
        let updatedTime = new Date(data.Last_Model_Updated_Date + " " + data.Last_Model_Updated_Time + " UTC");
        let currentDate = new Date();
        updatedTime.setMinutes(updatedTime.getMinutes() + 30);
        if (updatedTime < currentDate) return true;
        return false;
    }

    return <div className={`${_baseClassName}-header`}>
        <div className="display-section">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="page-title">{duplicateDocumentView ? "Duplicate Document Details Review" : "Document Details Review"}</p>
                {!duplicateDocumentView && <DocNavigation />}
            </div>

            <FileInformation />
            <EpicInformation />

        </div>
        { docMessage && <div
            className={
                data?.Entity_Details?.fax_cover_page_drop?.status === "In Progress" ||
                    (data.Status === "Failed" && data.Failure_Message) ?
                    "failure-msg" : "doc-info-msg"}>
            <Info size="small" style={{ marginRight: "5px" }} />
            <div>{docMessage}</div>
        </div> }
        <div className={data.Active_Users.status === "active" ? "border-blue" : (data.Active_Users.status == "stuck" || isDocSplitStuck) ? "border-red" : "border-below"}></div>
        {(data.Active_Users.status == "active" || data.Active_Users.status === "stuck" || isDocSplitStuck) &&
            <div
                className={"file-lock-strip " +
                    (data.Active_Users.status === "active" ?
                        "blue-strip" : (
                            (data.Active_Users.status === "stuck" || isDocSplitStuck) ?
                                "red-strip" : ""))}
            >
                <div style={{ color: 'white' }}>{isDocSplitStuck ? msg.docSplitStuckWarning : msg.file_lock_msg}</div>
            </div>
        }
    </div>
}

export default Header;